import script from "./AssetsBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsBusiness.vue?vue&type=script&setup=true&lang=js"

import "./AssetsBusiness.vue?vue&type=style&index=0&id=24c38f4c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c38f4c"]])

export default __exports__